<template>
    <div class="detail mt-5">
        <div class="info">
            <div class="mt">商家介绍</div>
            <div class="mc">{{organization_info.o2o_fuwu_organization_detail}}</div>
        </div>
        <div class="info">
            <div class="mt">商家信息</div>
            <div class="mc">
                <ul>
                    <li>
                        <i class="icon iconfont">&#xe65b;</i>
                        <div class="title">{{organization_info.o2o_fuwu_organization_phone}}</div>
                    </li>
                    <li>
                        <i class="icon iconfont">&#xe6ed;</i>
                        <div class="title">{{organization_info.o2o_fuwu_organization_region_name}}{{organization_info.o2o_fuwu_organization_city_name}}{{organization_info.o2o_fuwu_organization_address}}</div>
                    </li>
                    <li>
                        <i class="icon iconfont">&#xe63c;</i>
                        <div class="title">{{organization_info.o2o_fuwu_organization_type?'成立时间':'出生日期'}}：{{$moment.unix(organization_info.o2o_fuwu_organization_birthday).format('YYYY年MM月DD日')}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="info" v-if="qualityList.length>0">
            <div class="mt">资质证书</div>
            <div class="mc">
                <div class="image-list">
                    <div class="image-wrapper" v-for="(item,index) in qualityList" :key="index" @click="showImage(item.o2o_fuwu_upload_url_url)"><img :src="item.o2o_fuwu_upload_url_url"></div>
                </div>
            </div>
        </div>
        <div class="info" v-if="sceneList.length>0">
            <div class="mt">工作实景</div>
            <div class="mc">
                <div class="image-list">
                    <div class="image-wrapper" v-for="(item,index) in sceneList" :key="index" @click="showImage(item.o2o_fuwu_upload_url_url)"><img :src="item.o2o_fuwu_upload_url_url"></div>
                </div>
            </div>
        </div>
        <mt-popup v-model="isshow" popup-transition="popup-fade" class="middle-popup">
            <img :src="showUrl">
        </mt-popup>
    </div>
</template>

<script>
import { getFileList } from '../../../api/fuwuOrganization'
export default {
  name: 'Info',
  props: {
    organization_info: {}
  },
  data () {
    return {
      isshow: false,
      showUrl: '',
      qualityList: [],
      sceneList: []
    }
  },
  watch: {
    organization_info: function (organization_info) {
      if (organization_info) {
        getFileList(organization_info.o2o_fuwu_organization_id).then(res => {
          this.qualityList = res.result.quality_list
          this.sceneList = res.result.scene_list
        })
      }
    }
  },
  created: function () {

  },
  methods: {
    showImage (url) {
      this.showUrl = url
      this.isshow = true
    }
  }
}
</script>

<style scoped lang="scss">
    .detail{background:#fff;    padding:0.7rem;}
    .info{border-bottom: 1px solid #eee;padding: 0.5rem 0.75rem;}
    .info .mt{font-size:0.8rem;line-height:1.2rem;margin-bottom:0.3rem;}
    .info .mc{font-size:0.7rem;line-height:1rem;color: #999;}
    .info .mc li{display: flex;align-items: center;background-color: #fff;line-height:1rem;margin-bottom:0.2rem;}
    .info .mc li .icon{width: 1rem;height: 1rem;text-align: center;font-size: .8rem;}
    .info .mc li .title{    flex: 1;margin-left:.2rem;font-size: .6rem;color: #666;}
    .info .mc li .indicator{width: .4rem;margin-left: .5rem;margin-right: 1rem;}
    .image-list{overflow:hidden;
        .image-wrapper{width:33.33%;float: left;text-align: center;
            img{width:4.5rem;height:4.5rem;}
        }
    }
    .middle-popup{width:80%;text-align: center;
        img{max-width: 100%}
    }
</style>
